import React from 'react'

import GoogleIcon from '../../../../components/icon/GoogleIcon'
import { STORE_RELATION_FORM_TEXT } from '../constants/storeRelationFormConstants'

const StoreRelationFormHeader = ({
  pageDescription,
  isSaving = false,
  saveButtonLabel,
  onCancel,
  onSave
}) => (
  <div className="store-relations-form__header">
    <p className="store-relations-form__description">{pageDescription}</p>

    <div className="store-relations-details-header__actions">
      <button
        type="button"
        className="store-relations-details-btn store-relations-details-btn--secondary"
        onClick={onCancel}
        disabled={isSaving}
      >
        {STORE_RELATION_FORM_TEXT.CANCEL}
      </button>

      <button
        type="button"
        className="store-relations-details-btn store-relations-details-btn--primary"
        onClick={onSave}
        disabled={isSaving}
      >
        <GoogleIcon
          name="check_circle"
          size={16}
          filled={false}
          className="store-relations-details-btn__icon"
        />
        {isSaving ? STORE_RELATION_FORM_TEXT.SAVING : saveButtonLabel}
      </button>
    </div>
  </div>
)

export default StoreRelationFormHeader
